import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

const updates = [
  {
    date: "April 30, 2025",
    title: "Version 2.0 Release",
    description: "Added contact page, update page, dark mode, and profile dropdown.",
  },
  {
    date: "March 2025",
    title: "Enhanced Animations",
    description: "Introduced Framer Motion for smooth transitions and hover effects.",
  },
  {
    date: "February 2025",
    title: "Initial Launch",
    description: "Launched BRT website with profiles, studio, and cloud services.",
  },
];

const Update = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      className="container mx-auto p-4"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <motion.h1
        className="text-3xl font-bold text-center primary-text mb-8"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {t("update.title")}
      </motion.h1>
      <div className="max-w-2xl mx-auto">
        {updates.map((update, index) => (
          <motion.div
            key={index}
            className="glass p-6 rounded-lg mb-6 card"
            initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            viewport={{ once: true }}
          >
            <h3 className="text-xl font-semibold primary-text">{update.title}</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">{update.date}</p>
            <p className="mt-2">{update.description}</p>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default Update;